import FeaturePage from "../../components/FeaturePage";
import { Globe, Palette, ShoppingBag, Truck, CreditCard, Tag } from "lucide-react";

export default function SellOnline() {
  return (
    <FeaturePage
      badge="Sell Online"
      title="Launch a beautiful storefront."
      highlight="In an afternoon."
      subtitle="Get a website, custom domain, run flash sales, and start collecting orders without writing a line of code. Brivo handles the heavy lifting."
      heroImage="https://images.unsplash.com/photo-1763718528755-4bca23f82ac3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
      heroBg="pink"
      features={[
        { icon: <Globe size={22} />, title: "Custom domain", desc: "Bring your own domain or use a free brivo.shop subdomain. SSL included." },
        { icon: <Palette size={22} />, title: "Drag-and-drop builder", desc: "Beautiful templates that don't look templated. Customize colors, fonts, layout." },
        { icon: <ShoppingBag size={22} />, title: "Smart product pages", desc: "Variants, bundles, upsells — built in. Auto-optimized for conversions." },
        { icon: <Truck size={22} />, title: "Shipping built in", desc: "Real-time rates, label printing, and tracking emails out of the box." },
        { icon: <CreditCard size={22} />, title: "Checkout that converts", desc: "One-page checkout, guest mode, and saved cards reduce drop-off by 38%." },
        { icon: <Tag size={22} />, title: "Sales & discounts", desc: "Run flash sales, BOGO, % off, free shipping, automatic discounts." },
      ]}
      details={[
        {
          tag: "Storefront",
          title: "A storefront that looks like you spent $50K on it.",
          desc: "Choose from designer-crafted templates, then make it yours. Mobile-perfect, lightning-fast, and SEO-ready by default.",
          bullets: ["20+ premium themes", "Mobile-first by design", "Built-in SEO & meta editor"],
          image: "https://images.pexels.com/photos/27141314/pexels-photo-27141314.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
        },
        {
          tag: "Conversion",
          title: "Turn browsers into buyers.",
          desc: "Abandoned cart recovery, pop-ups, exit intent, upsells — everything you need to win the order, without paying for 5 different apps.",
          bullets: ["Abandoned cart emails", "Exit-intent popups", "Smart upsells & cross-sells"],
        },
        {
          tag: "Domains",
          title: "Look professional from day one.",
          desc: "Connect a domain you already own, or grab a fresh one through Brivo. SSL, email forwarding, and DNS — all sorted.",
        },
      ]}
      useCases={[
        { title: "Fashion brands", desc: "Variants, lookbooks, drop campaigns and gift cards built in." },
        { title: "F&B & specialty", desc: "Subscriptions, delivery zones, and pickup scheduling supported." },
        { title: "Service businesses", desc: "Bookings, deposits, and digital downloads handled natively." },
        { title: "B2B sellers", desc: "Tiered pricing, NET terms, and quotes for wholesale clients." },
      ]}
      ctaTitle="Your storefront. Live by tonight."
      ctaSubtitle="Spin up a beautiful Brivo store in minutes — and keep every sale you make."
      ctaAccent="pink"
    />
  );
}
